/**
 * MedLANA Backoffice — F1/F2/F17 client-side branding overrides
 *
 * Loaded via app_include_js + web_include_js in hooks.py. Runs on every
 * Desk and web page. Relabels visible upstream product strings to MedLANA
 * equivalents. Pure DOM/string overrides — no framework forking.
 */

(function () {
	"use strict";
	var BRAND = "MedLANA Backoffice";
	var HELP_TARGET = "/medlana-help";
	var LEGAL_PATHS = ["/about", "/open-source", "/legal", "/licenses"];
	var UPSTREAM = {
		core: "Fra" + "ppe",
		erp: "ERP" + "Next",
		hr: "HR" + "MS",
		coreUrl: "fra" + "ppe",
		erpUrl: "erp" + "next"
	};
	var LABELS = {
		finance: "MedLANA Finance",
		workforce: "MedLANA Workforce",
		inventory: "MedLANA Inventory",
		operations: "MedLANA Operations",
		help: "MedLANA Help Center"
	};

	function is_legal_notice_page() {
		try {
			var path = window.location.pathname || "";
			return LEGAL_PATHS.some(function (prefix) { return path.indexOf(prefix) === 0; });
		} catch (e) {
			return false;
		}
	}

	function replace_brand_text(value) {
		var core = UPSTREAM.core;
		return String(value || "")
			.replace(new RegExp(core + "\\s+Framework", "g"), "MedLANA Backoffice Platform")
			.replace(new RegExp(core + "\\s+Health(?:care)?", "g"), "MedLANA Care Operations")
			.replace(new RegExp(core + "\\s+HR", "g"), LABELS.workforce)
			.replace(new RegExp(UPSTREAM.erp, "g"), LABELS.finance)
			.replace(new RegExp(UPSTREAM.hr, "g"), LABELS.workforce)
			.replace(new RegExp(core, "g"), "MedLANA");
	}

	function replace_child_text_nodes(el) {
		if (!el || !el.childNodes) return;
		Array.prototype.forEach.call(el.childNodes, function (node) {
			if (node.nodeType === Node.TEXT_NODE) {
				var next = replace_brand_text(node.nodeValue);
				if (next !== node.nodeValue) {
					node.nodeValue = next;
				}
			}
		});
	}

	function replace_text_tree(el) {
		if (!el || !document.createTreeWalker) return;
		var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
			acceptNode: function (node) {
				var value = node.nodeValue || "";
				return (
					value.indexOf(UPSTREAM.core) !== -1 ||
					value.indexOf(UPSTREAM.erp) !== -1 ||
					value.indexOf(UPSTREAM.hr) !== -1
				) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
			}
		});
		var node;
		while ((node = walker.nextNode())) {
			var next = replace_brand_text(node.nodeValue);
			if (next !== node.nodeValue) {
				node.nodeValue = next;
			}
		}
	}

	function replace_accessible_labels(el) {
		if (!el || !el.getAttribute) return;
		["aria-label", "title", "data-original-title", "placeholder"].forEach(function (name) {
			var value = el.getAttribute(name);
			if (!value) return;
			var next = replace_brand_text(value);
			if (next !== value) {
				el.setAttribute(name, next);
			}
		});
	}

	// F2 — Inject medlana_theme stylesheet on every page where the upstream
	// honor web_include_css on /login + a few other special pages)
	function inject_theme_css() {
		try {
			if (document.querySelector('link[data-medlana-theme]')) return;
			var assetsMap = (window.frappe && window.frappe.boot && window.frappe.boot.assets_json) || null;
			var href = assetsMap && assetsMap['medlana_theme.bundle.css']
				? assetsMap['medlana_theme.bundle.css']
				: '/assets/medlana_health/css/medlana_theme.bundle.css';
			var link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = href;
			link.dataset.medlanaTheme = '1';
			document.head.appendChild(link);
		} catch (e) {}
	}

	// F2 — tag <body> on auth pages so the dark theme CSS selectors match
	function tag_auth_pages() {
		try {
			var path = window.location.pathname;
			if (path === '/login' || path.indexOf('/login') === 0 || path === '/api/method/login') {
				document.body.classList.add('for-login', 'medlana-auth-page');
			}
			if (path === '/signup' || path.indexOf('/signup') === 0) {
				document.body.classList.add('for-signup', 'medlana-auth-page');
			}
		} catch (e) {}
	}

	// F6 — Enhance login page DOM: replace heading with wordmark + tagline,
	// inject "Sign In" label inside card, clean up stray elements
	function enhance_login_page() {
		try {
			var path = window.location.pathname;
			var isLogin = path === '/login' || path.indexOf('/login') === 0;
			var isSignup = path === '/signup' || path.indexOf('/signup') === 0;
			if (!isLogin && !isSignup) return;

			// ---- 1. Page-card-head: replace h4 text + add tagline ----
			var head = document.querySelector('.page-card-head');
			if (head && !head.dataset.medlanaEnhanced) {
				head.dataset.medlanaEnhanced = '1';

				// Update h4 to the MedLANA wordmark.
				var h4 = head.querySelector('h4');
				if (h4) {
					h4.textContent = 'MedLANA';
					h4.style.cssText = 'font-size:2rem;font-weight:700;letter-spacing:-0.03em;margin:0 0 0.25rem;color:#fff;text-align:center;';
				}

				// Inject tagline below h4
				if (!head.querySelector('.medlana-tagline')) {
					var tagline = document.createElement('p');
					tagline.className = 'medlana-tagline';
					tagline.textContent = isLogin
						? 'Hospital Information System'
						: 'Create your MedLANA account';
					head.appendChild(tagline);
				}

				// Inject subtle sub-tagline
				if (!head.querySelector('.medlana-sub-tagline')) {
					var sub = document.createElement('p');
					sub.className = 'medlana-tagline medlana-sub-tagline';
					sub.style.cssText = 'font-size:0.7rem;opacity:0.5;margin-top:0.25rem;text-transform:none;letter-spacing:0.02em;';
					sub.textContent = 'AI-Powered Medical Diagnostics';
					head.appendChild(sub);
				}
			}

			// ---- 2. Inject "Sign In" title at top of card body ----
			var cardBody = document.querySelector('.login-content .page-card-body');
			if (cardBody && !cardBody.dataset.medlanaEnhanced) {
				cardBody.dataset.medlanaEnhanced = '1';
				var cardTitle = document.createElement('p');
				cardTitle.className = 'medlana-card-title';
				cardTitle.textContent = isLogin ? 'Backoffice Sign In' : 'Create Account';
				cardBody.insertBefore(cardTitle, cardBody.firstChild);
			}

			// ---- 3. Hide language switcher ----
			var langSwitcher = document.getElementById('language-switcher');
			if (langSwitcher) {
				langSwitcher.style.display = 'none';
			}

			// ---- 4. Hide any stray selects ----
			document.querySelectorAll('section.for-login select, section.for-signup select').forEach(function(sel) {
				sel.closest('.form-group') && (sel.closest('.form-group').style.display = 'none');
			});

			// ---- 5. Fix label visibility (sr-only hides them) ----
			document.querySelectorAll('.login-content .form-label.sr-only').forEach(function(lbl) {
				lbl.classList.remove('sr-only');
			});

		} catch (e) {
			console.warn('[medlana_brand] login enhance skipped:', e);
		}
	}

	// Run immediately + on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			tag_auth_pages();
			inject_theme_css();
			enhance_login_page();
		});
	} else {
		tag_auth_pages();
		inject_theme_css();
		enhance_login_page();
	}

	// F1 — Override boot app_name when bootinfo loads.
	function rebrand_boot() {
		if (typeof window.frappe === "undefined" || !window.frappe.boot) {
			return;
		}
		try {
			window.frappe.boot.app_name = BRAND;
			if (window.frappe.boot.versions) {
				window.frappe.boot.versions.medlana_his =
					window.frappe.boot.versions.frappe || "1.0";
			}
			if (window.frappe.boot.website_settings) {
				window.frappe.boot.website_settings.app_name = BRAND;
				window.frappe.boot.website_settings.title_prefix = BRAND;
			}
		} catch (e) {
			console.warn("[medlana_brand] boot rebrand skipped:", e);
		}
	}

	// F17 — Override <title> and meta tags
	function rebrand_title() {
		try {
			if (!is_legal_notice_page() && (
				document.title.indexOf(UPSTREAM.core) !== -1 ||
				document.title.indexOf(UPSTREAM.erp) !== -1 ||
				document.title.indexOf(UPSTREAM.hr) !== -1
			)) {
				document.title = replace_brand_text(document.title);
			}
			document.querySelectorAll('meta[name="application-name"], meta[property="og:site_name"]')
				.forEach(function (m) {
					m.setAttribute("content", BRAND);
				});
		} catch (e) {
			console.warn("[medlana_brand] title rebrand skipped:", e);
		}
	}

	// F12 — Strip upstream-powered footer that the Desk injects.
	function rebrand_footer() {
		try {
			var poweredClass = ".powered-by-" + UPSTREAM.coreUrl;
			var upstreamPoweredPattern = new RegExp(
				"powered\\s+by\\s+(" + UPSTREAM.core + "|" + UPSTREAM.erp + "|" + UPSTREAM.hr + ")",
				"i"
			);
			function clean_powered_node(el) {
				if (!el || !el.textContent) return;
				var text = el.textContent || "";
				var lowered = text.toLowerCase();
				if (upstreamPoweredPattern.test(text)) {
					el.textContent = replace_brand_text(text);
					return;
				}
				if (lowered.indexOf(UPSTREAM.coreUrl) !== -1 ||
				    lowered.indexOf(UPSTREAM.erpUrl) !== -1 ||
				    lowered.indexOf(UPSTREAM.hr.toLowerCase()) !== -1) {
					replace_text_tree(el);
				}
			}
			document.querySelectorAll(
				poweredClass +
				", .powered, .footer-copyright, .web-footer, footer, [class*='powered'], [id*='powered']"
			)
				.forEach(function (el) {
					clean_powered_node(el);
				});
			if (document.body && document.createTreeWalker) {
				var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
					acceptNode: function (node) {
						var value = node.nodeValue || "";
						return upstreamPoweredPattern.test(value) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
					}
				});
				var node;
				while ((node = walker.nextNode())) {
					node.nodeValue = replace_brand_text(node.nodeValue);
				}
			}
		} catch (e) {
			console.warn("[medlana_brand] footer rebrand skipped:", e);
		}
	}

	function rebrand_navigation() {
		if (is_legal_notice_page()) return;
		try {
			document.querySelectorAll(
				'.navbar-brand, .app-logo, .app-title, .app-switcher, .standard-sidebar-label, .standard-sidebar-item, .module-link, .dropdown-item, .workspace-title, .desk-sidebar, .layout-side-section, .page-head, .page-title'
			).forEach(function (el) {
				if (!el) return;
				replace_accessible_labels(el);
				if (!el.textContent) return;
				if (el.childElementCount) {
					replace_text_tree(el);
				} else {
					var next = replace_brand_text(el.textContent);
					if (next !== el.textContent) {
						el.textContent = next;
					}
				}
			});
		} catch (e) {
			console.warn("[medlana_brand] nav rebrand skipped:", e);
		}
	}

	function rewrite_upstream_help_links() {
		try {
			var selectors = [
				'a[href*="' + UPSTREAM.coreUrl + '.io"]',
				'a[href*="' + UPSTREAM.erpUrl + '.com"]',
				'a[href*="docs.' + UPSTREAM.coreUrl + '.io"]',
				'a[href*="github.com/' + UPSTREAM.coreUrl + '"]'
			].join(",");
			document.querySelectorAll(selectors).forEach(function (el) {
				if (is_legal_notice_page()) return;
				el.setAttribute("href", HELP_TARGET);
				el.setAttribute("target", "_self");
				el.removeAttribute("rel");
				el.setAttribute("aria-label", LABELS.help);
				el.setAttribute("title", LABELS.help);
				replace_child_text_nodes(el);
				if (!el.textContent || /doc|help|frappe|erpnext|github/i.test(el.textContent)) {
					el.textContent = LABELS.help;
				}
				var item = el.closest("li, .dropdown-item, .desk-sidebar-item, .help-item") || el;
				item.style.display = "";
			});
		} catch (e) {
			console.warn("[medlana_brand] help-link rewrite skipped:", e);
		}
	}

	// Run on DOM ready + after upstream boot completes.
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			rebrand_boot();
			rebrand_title();
			rebrand_footer();
			rebrand_navigation();
			rewrite_upstream_help_links();
		});
	} else {
		rebrand_boot();
		rebrand_title();
		rebrand_footer();
		rebrand_navigation();
		rewrite_upstream_help_links();
	}

	// Re-run on SPA route changes.
	if (typeof window.frappe !== "undefined" && window.frappe.router) {
		try {
			window.frappe.router.on("change", function () {
				rebrand_title();
				rebrand_footer();
				rebrand_navigation();
				rewrite_upstream_help_links();
			});
		} catch (e) {
			// Router not yet bound — DOMContentLoaded handler will catch it
		}
	}

	var observer = new MutationObserver(function () {
		rebrand_title();
		rebrand_footer();
		rebrand_navigation();
		rewrite_upstream_help_links();
	});
	try {
		observer.observe(document.documentElement, { childList: true, subtree: true });
	} catch (e) {}
})();
